import { render, staticRenderFns } from "./ICD10Editor.vue?vue&type=template&id=4c64080e&scoped=true"
import script from "./ICD10Editor.vue?vue&type=script&lang=js"
export * from "./ICD10Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64080e",
  null
  
)

export default component.exports